// Copy for the tasting flow (start, lobby, the guided steps, the quick page, the sheets to add a
// wine, invite people and switch wine) and the names of the 17 aroma families. Our own words: the
// structure of the method is shared knowledge, the wording is not borrowed from any exam body or
// aroma wheel. One entry per locale; every key exists in all seven (nl is the source, the rest are
// translations). The wine words themselves (ladders, hues, verdicts) stay with the note copy.
export const tastingCopy = {
  nl: {
    "tasting.flow.start.title": "Nieuwe proeverij",
    "tasting.flow.start.heading": "Proeverij",
    "tasting.flow.start.paths":
      "Alle drie komen in dezelfde proeverij uit. Je kunt later altijd mensen en wijnen toevoegen.",
    "tasting.flow.depth.label": "Diepte",
    "tasting.flow.depth.full": "Volledig",
    "tasting.flow.depth.quick": "Snel",
    "tasting.flow.start.fullHint": "Volledig: uiterlijk, neus, mond en structuur, stap voor stap.",
    "tasting.flow.start.quickHint":
      "Snel: alleen aromafamilies, een score en je opmerkingen — ±90 seconden per wijn.",
    "tasting.flow.start.scan": "Scan een fles",
    "tasting.flow.start.invite": "Nodig mensen uit",
    "tasting.flow.start.share": "Deel link of QR",
    "tasting.flow.start.blind": "Blind proeven",
    "tasting.flow.start.blindHint": "Etiketten blijven verborgen tot de onthulling",
    "tasting.flow.start.later": "Mensen toevoegen kan ook tijdens het proeven.",
    "tasting.flow.start.resumeTitle": "Je hebt nog een proeverij open",
    "tasting.flow.start.resumeBody": "{title}: {done} van {total} wijnen klaar.",
    "tasting.flow.start.resume": "Hervatten",
    "tasting.flow.start.discard": "Begin opnieuw",
    "tasting.flow.lobby.ready": "{done} van {total} klaar",
    "tasting.flow.lobby.empty": "Nog geen wijnen. Voeg er een toe om te beginnen.",
    "tasting.flow.lobby.wines": "Wijnen",
    "tasting.flow.lobby.people": "Mensen ({n})",
    "tasting.flow.lobby.joined": "{names} doen mee",
    "tasting.flow.lobby.invited": "{names} uitgenodigd",
    "tasting.flow.lobby.alone": "Alleen jij, voor nu.",
    "tasting.flow.lobby.code": "Code",
    "tasting.flow.lobby.copyLink": "Kopieer link",
    "tasting.flow.lobby.copied": "Link gekopieerd",
    "tasting.flow.lobby.linkHint":
      "Wie de link opent of de code scant, doet mee in deze proeverij.",
    "tasting.flow.lobby.makeLink": "Link of QR maken",
    "tasting.flow.lobby.begin": "Begin met wijn {n}",
    "tasting.flow.lobby.needWine": "Voeg eerst een wijn toe om te beginnen.",
    "tasting.flow.lobby.waiting": "Wacht op de anderen",
    "tasting.flow.lobby.waitingHost": "Wacht tot de gastheer begint",
    "tasting.flow.lobby.blindWine": "Wijn {n} (blind)",
    "tasting.flow.lobby.refresh": "Verversen",
    "tasting.flow.wineOf": "{n} / {total}",
    "tasting.flow.step": "Stap {n} van {total}: {name}",
    "tasting.flow.steps": "Stappen",
    "tasting.flow.invite": "Uitnodigen",
    "tasting.flow.addWine": "Wijn toevoegen",
    "tasting.flow.next": "Verder · {name}",
    "tasting.flow.structure": "Structuur & oordeel",
    "tasting.flow.summary": "Samenvatting",
    "tasting.flow.blindCard": "Blind: het etiket blijft verborgen",
    "tasting.flow.blindCardHint": "De kleur kijk je wel af.",
    "tasting.flow.mystery": "Mysteriefles",
    "tasting.flow.progress": "Voortgang",
    "tasting.flow.wines": "Wijnen",
    "tasting.flow.aroma.selected": "Gekozen",
    "tasting.flow.aroma.count": "{n} gekozen",
    "tasting.flow.aroma.primary": "Uit de druif",
    "tasting.flow.aroma.secondary": "Uit de kelder",
    "tasting.flow.aroma.tertiary": "Uit de tijd",
    "tasting.flow.aroma.sameAsNose": "Zelfde als neus",
    "tasting.flow.aroma.remove": "{name} verwijderen",
    "tasting.flow.aroma.cap": "Kies tot {n} families.",
    "tasting.flow.aroma.swatch": "Kleur van de familie {name}",
    "tasting.flow.more": "Meer (zoetheid, body, afdronk, mousse)",
    "tasting.flow.summary.hint": "Tik op een regel om die stap aan te passen",
    "tasting.flow.summary.nothing": "Niets gekozen",
    "tasting.flow.summary.offline":
      "Geen verbinding — je notitie wordt bewaard en later verstuurd.",
    "tasting.flow.summary.queued":
      "Bewaard op dit apparaat; het wordt verstuurd zodra er verbinding is.",
    "tasting.flow.summary.needsVerdict": "Kies eerst een oordeel bij Structuur & oordeel.",
    "tasting.flow.summary.saveNext": "Opslaan en naar wijn {n}",
    "tasting.flow.summary.overview": "Naar overzicht",
    "tasting.flow.grow.title": "Proeverij uitbreiden",
    "tasting.flow.grow.hint": "De nieuwe wijn wordt wijn {n} en verschijnt meteen bij iedereen.",
    "tasting.flow.grow.hintSolo": "De nieuwe wijn wordt wijn {n}.",
    "tasting.flow.grow.scan": "Fles scannen",
    "tasting.flow.grow.search": "Wijn zoeken",
    "tasting.flow.grow.blind": "Blinde wijn toevoegen",
    "tasting.flow.grow.invite": "Mensen uitnodigen",
    "tasting.flow.grow.share": "Link of QR delen",
    "tasting.flow.grow.hostOnly": "Alleen de gastheer voegt wijnen toe.",
    "tasting.flow.grow.searchTitle": "Wijn zoeken",
    "tasting.flow.grow.addAs": "Toevoegen als wijn {n}",
    "tasting.flow.invite.title": "Mensen uitnodigen",
    "tasting.flow.invite.friends": "Vrienden",
    "tasting.flow.invite.group": "Groep",
    "tasting.flow.invite.link": "Link / QR",
    "tasting.flow.invite.send": "Uitnodiging sturen ({n})",
    "tasting.flow.invite.sent": "Uitgenodigd.",
    "tasting.flow.invite.signIn": "Log in om vrienden en groepen uit te nodigen.",
    "tasting.flow.invite.qr": "QR-code van de proeverij",
    "tasting.flow.invite.pending": "Uitgenodigd",
    "tasting.flow.people.host": "Gastheer",
    "tasting.flow.people.you": "Jij",
    "tasting.flow.switch.title": "Overzicht",
    "tasting.flow.switch.switch": "Wissel van wijn",
    "tasting.flow.switch.done": "Geproefd",
    "tasting.flow.switch.now": "Nu",
    "tasting.flow.switch.todo": "Nog niet",
    "tasting.flow.switch.matrix": "Voortgang per persoon",
    "tasting.flow.switch.counts": "{done} van {total} klaar",
    "tasting.flow.switch.results": "Naar de gezamenlijke proeverij",
    "tasting.flow.quick.title": "Snelle proef",
    "tasting.flow.quick.score": "Score",
    "tasting.flow.quick.scoreHint": "Eén tik is genoeg",
    "tasting.flow.quick.comments": "Opmerkingen",
    "tasting.flow.quick.done": "Klaar",
    "tasting.flow.quick.families": "{n} families",
    "tasting.flow.finish": "Proeverij afronden",
    "tasting.flow.flight.mine": "Mijn proeverij",
    "journal.tasting.label": "Nieuwe proeverij",
    "aroma.family.floral": "Bloemig",
    "aroma.family.green-fruit": "Groen fruit",
    "aroma.family.citrus": "Citrus",
    "aroma.family.stone-fruit": "Steenfruit",
    "aroma.family.tropical-fruit": "Tropisch fruit",
    "aroma.family.red-fruit": "Rood fruit",
    "aroma.family.black-fruit": "Zwart fruit",
    "aroma.family.herbaceous": "Vegetaal",
    "aroma.family.herbal": "Kruiden",
    "aroma.family.spice-fresh": "Pittige specerij",
    "aroma.family.mineral": "Mineraal",
    "aroma.family.yeast": "Gist & schil",
    "aroma.family.malolactic": "Romig",
    "aroma.family.oak": "Eik",
    "aroma.family.oxidative": "Bewuste oxidatie",
    "aroma.family.fruit-development": "Fruitontwikkeling",
    "aroma.family.bottle-age": "Flesrijping",
  },
  en: {
    "tasting.flow.start.title": "New tasting",
    "tasting.flow.start.heading": "Tasting",
    "tasting.flow.start.paths":
      "All three land in the same tasting. You can add people and wines at any time.",
    "tasting.flow.depth.label": "Depth",
    "tasting.flow.depth.full": "Full",
    "tasting.flow.depth.quick": "Quick",
    "tasting.flow.start.fullHint": "Full: look, nose, palate and structure, step by step.",
    "tasting.flow.start.quickHint":
      "Quick: aroma families only, a score and your comments — about 90 seconds per wine.",
    "tasting.flow.start.scan": "Scan a bottle",
    "tasting.flow.start.invite": "Invite people",
    "tasting.flow.start.share": "Share link or QR",
    "tasting.flow.start.blind": "Taste blind",
    "tasting.flow.start.blindHint": "Labels stay hidden until the reveal",
    "tasting.flow.start.later": "You can add people while tasting too.",
    "tasting.flow.start.resumeTitle": "You still have a tasting open",
    "tasting.flow.start.resumeBody": "{title}: {done} of {total} wines done.",
    "tasting.flow.start.resume": "Resume",
    "tasting.flow.start.discard": "Start over",
    "tasting.flow.lobby.ready": "{done} of {total} done",
    "tasting.flow.lobby.empty": "No wines yet. Add one to begin.",
    "tasting.flow.lobby.wines": "Wines",
    "tasting.flow.lobby.people": "People ({n})",
    "tasting.flow.lobby.joined": "{names} joined",
    "tasting.flow.lobby.invited": "{names} invited",
    "tasting.flow.lobby.alone": "Just you, for now.",
    "tasting.flow.lobby.code": "Code",
    "tasting.flow.lobby.copyLink": "Copy link",
    "tasting.flow.lobby.copied": "Link copied",
    "tasting.flow.lobby.linkHint":
      "Anyone who opens the link or scans the code joins this tasting.",
    "tasting.flow.lobby.makeLink": "Make a link or QR",
    "tasting.flow.lobby.begin": "Start with wine {n}",
    "tasting.flow.lobby.needWine": "Add a wine first to begin.",
    "tasting.flow.lobby.waiting": "Waiting for the others",
    "tasting.flow.lobby.waitingHost": "Waiting for the host to begin",
    "tasting.flow.lobby.blindWine": "Wine {n} (blind)",
    "tasting.flow.lobby.refresh": "Refresh",
    "tasting.flow.wineOf": "{n} / {total}",
    "tasting.flow.step": "Step {n} of {total}: {name}",
    "tasting.flow.steps": "Steps",
    "tasting.flow.invite": "Invite",
    "tasting.flow.addWine": "Add wine",
    "tasting.flow.next": "Continue · {name}",
    "tasting.flow.structure": "Structure & verdict",
    "tasting.flow.summary": "Summary",
    "tasting.flow.blindCard": "Blind: the label stays hidden",
    "tasting.flow.blindCardHint": "You still judge the colour.",
    "tasting.flow.mystery": "Mystery bottle",
    "tasting.flow.progress": "Progress",
    "tasting.flow.wines": "Wines",
    "tasting.flow.aroma.selected": "Chosen",
    "tasting.flow.aroma.count": "{n} chosen",
    "tasting.flow.aroma.primary": "From the grape",
    "tasting.flow.aroma.secondary": "From the cellar",
    "tasting.flow.aroma.tertiary": "From time",
    "tasting.flow.aroma.sameAsNose": "Same as nose",
    "tasting.flow.aroma.remove": "Remove {name}",
    "tasting.flow.aroma.cap": "Choose up to {n} families.",
    "tasting.flow.aroma.swatch": "Colour of the {name} family",
    "tasting.flow.more": "More (sweetness, body, finish, mousse)",
    "tasting.flow.summary.hint": "Tap a line to change that step",
    "tasting.flow.summary.nothing": "Nothing chosen",
    "tasting.flow.summary.offline": "No connection — your note is kept and sent later.",
    "tasting.flow.summary.queued":
      "Kept on this device; it is sent as soon as there is a connection.",
    "tasting.flow.summary.needsVerdict": "Pick a verdict first, under Structure & verdict.",
    "tasting.flow.summary.saveNext": "Save and go to wine {n}",
    "tasting.flow.summary.overview": "To overview",
    "tasting.flow.grow.title": "Grow the tasting",
    "tasting.flow.grow.hint": "The new wine becomes wine {n} and shows up for everyone at once.",
    "tasting.flow.grow.hintSolo": "The new wine becomes wine {n}.",
    "tasting.flow.grow.scan": "Scan a bottle",
    "tasting.flow.grow.search": "Search a wine",
    "tasting.flow.grow.blind": "Add a blind wine",
    "tasting.flow.grow.invite": "Invite people",
    "tasting.flow.grow.share": "Share link or QR",
    "tasting.flow.grow.hostOnly": "Only the host adds wines.",
    "tasting.flow.grow.searchTitle": "Search a wine",
    "tasting.flow.grow.addAs": "Add as wine {n}",
    "tasting.flow.invite.title": "Invite people",
    "tasting.flow.invite.friends": "Friends",
    "tasting.flow.invite.group": "Group",
    "tasting.flow.invite.link": "Link / QR",
    "tasting.flow.invite.send": "Send invitation ({n})",
    "tasting.flow.invite.sent": "Invited.",
    "tasting.flow.invite.signIn": "Sign in to invite friends and groups.",
    "tasting.flow.invite.qr": "QR code of the tasting",
    "tasting.flow.invite.pending": "Invited",
    "tasting.flow.people.host": "Host",
    "tasting.flow.people.you": "You",
    "tasting.flow.switch.title": "Overview",
    "tasting.flow.switch.switch": "Switch wine",
    "tasting.flow.switch.done": "Tasted",
    "tasting.flow.switch.now": "Now",
    "tasting.flow.switch.todo": "Not yet",
    "tasting.flow.switch.matrix": "Progress per person",
    "tasting.flow.switch.counts": "{done} of {total} done",
    "tasting.flow.switch.results": "To the group tasting",
    "tasting.flow.quick.title": "Quick taste",
    "tasting.flow.quick.score": "Score",
    "tasting.flow.quick.scoreHint": "One tap is enough",
    "tasting.flow.quick.comments": "Comments",
    "tasting.flow.quick.done": "Done",
    "tasting.flow.quick.families": "{n} families",
    "tasting.flow.finish": "Finish the tasting",
    "tasting.flow.flight.mine": "My tasting",
    "journal.tasting.label": "New tasting",
    "aroma.family.floral": "Floral",
    "aroma.family.green-fruit": "Green fruit",
    "aroma.family.citrus": "Citrus",
    "aroma.family.stone-fruit": "Stone fruit",
    "aroma.family.tropical-fruit": "Tropical fruit",
    "aroma.family.red-fruit": "Red fruit",
    "aroma.family.black-fruit": "Black fruit",
    "aroma.family.herbaceous": "Herbaceous",
    "aroma.family.herbal": "Herbal",
    "aroma.family.spice-fresh": "Pungent spice",
    "aroma.family.mineral": "Mineral",
    "aroma.family.yeast": "Yeast & lees",
    "aroma.family.malolactic": "Creamy",
    "aroma.family.oak": "Oak",
    "aroma.family.oxidative": "Deliberate oxidation",
    "aroma.family.fruit-development": "Fruit development",
    "aroma.family.bottle-age": "Bottle age",
  },
  de: {
    "tasting.flow.start.title": "Neue Verkostung",
    "tasting.flow.start.heading": "Verkostung",
    "tasting.flow.start.paths":
      "Alle drei führen in dieselbe Verkostung. Personen und Weine kannst du jederzeit hinzufügen.",
    "tasting.flow.depth.label": "Tiefe",
    "tasting.flow.depth.full": "Vollständig",
    "tasting.flow.depth.quick": "Schnell",
    "tasting.flow.start.fullHint":
      "Vollständig: Aussehen, Nase, Gaumen und Struktur, Schritt für Schritt.",
    "tasting.flow.start.quickHint":
      "Schnell: nur Aromafamilien, eine Bewertung und deine Anmerkungen — etwa 90 Sekunden pro Wein.",
    "tasting.flow.start.scan": "Flasche scannen",
    "tasting.flow.start.invite": "Personen einladen",
    "tasting.flow.start.share": "Link oder QR teilen",
    "tasting.flow.start.blind": "Blind verkosten",
    "tasting.flow.start.blindHint": "Etiketten bleiben bis zur Enthüllung verborgen",
    "tasting.flow.start.later": "Personen kannst du auch während der Verkostung hinzufügen.",
    "tasting.flow.start.resumeTitle": "Du hast noch eine Verkostung offen",
    "tasting.flow.start.resumeBody": "{title}: {done} von {total} Weinen fertig.",
    "tasting.flow.start.resume": "Fortsetzen",
    "tasting.flow.start.discard": "Neu beginnen",
    "tasting.flow.lobby.ready": "{done} von {total} fertig",
    "tasting.flow.lobby.empty": "Noch keine Weine. Füge einen hinzu, um zu beginnen.",
    "tasting.flow.lobby.wines": "Weine",
    "tasting.flow.lobby.people": "Personen ({n})",
    "tasting.flow.lobby.joined": "{names} sind dabei",
    "tasting.flow.lobby.invited": "{names} eingeladen",
    "tasting.flow.lobby.alone": "Vorerst nur du.",
    "tasting.flow.lobby.code": "Code",
    "tasting.flow.lobby.copyLink": "Link kopieren",
    "tasting.flow.lobby.copied": "Link kopiert",
    "tasting.flow.lobby.linkHint":
      "Wer den Link öffnet oder den Code scannt, nimmt an dieser Verkostung teil.",
    "tasting.flow.lobby.makeLink": "Link oder QR erstellen",
    "tasting.flow.lobby.begin": "Mit Wein {n} beginnen",
    "tasting.flow.lobby.needWine": "Füge zuerst einen Wein hinzu, um zu beginnen.",
    "tasting.flow.lobby.waiting": "Warten auf die anderen",
    "tasting.flow.lobby.waitingHost": "Warten, bis der Gastgeber beginnt",
    "tasting.flow.lobby.blindWine": "Wein {n} (blind)",
    "tasting.flow.lobby.refresh": "Aktualisieren",
    "tasting.flow.wineOf": "{n} / {total}",
    "tasting.flow.step": "Schritt {n} von {total}: {name}",
    "tasting.flow.steps": "Schritte",
    "tasting.flow.invite": "Einladen",
    "tasting.flow.addWine": "Wein hinzufügen",
    "tasting.flow.next": "Weiter · {name}",
    "tasting.flow.structure": "Struktur & Urteil",
    "tasting.flow.summary": "Zusammenfassung",
    "tasting.flow.blindCard": "Blind: das Etikett bleibt verborgen",
    "tasting.flow.blindCardHint": "Die Farbe beurteilst du trotzdem.",
    "tasting.flow.mystery": "Mystery-Flasche",
    "tasting.flow.progress": "Fortschritt",
    "tasting.flow.wines": "Weine",
    "tasting.flow.aroma.selected": "Gewählt",
    "tasting.flow.aroma.count": "{n} gewählt",
    "tasting.flow.aroma.primary": "Von der Traube",
    "tasting.flow.aroma.secondary": "Aus dem Keller",
    "tasting.flow.aroma.tertiary": "Von der Zeit",
    "tasting.flow.aroma.sameAsNose": "Wie die Nase",
    "tasting.flow.aroma.remove": "{name} entfernen",
    "tasting.flow.aroma.cap": "Wähle bis zu {n} Familien.",
    "tasting.flow.aroma.swatch": "Farbe der Familie {name}",
    "tasting.flow.more": "Mehr (Süße, Körper, Abgang, Mousseux)",
    "tasting.flow.summary.hint": "Tippe auf eine Zeile, um diesen Schritt zu ändern",
    "tasting.flow.summary.nothing": "Nichts gewählt",
    "tasting.flow.summary.offline":
      "Keine Verbindung — deine Notiz wird bewahrt und später gesendet.",
    "tasting.flow.summary.queued":
      "Auf diesem Gerät gespeichert; sie wird gesendet, sobald wieder eine Verbindung besteht.",
    "tasting.flow.summary.needsVerdict": "Wähle zuerst ein Urteil unter Struktur & Urteil.",
    "tasting.flow.summary.saveNext": "Speichern und weiter zu Wein {n}",
    "tasting.flow.summary.overview": "Zur Übersicht",
    "tasting.flow.grow.title": "Verkostung erweitern",
    "tasting.flow.grow.hint": "Der neue Wein wird Wein {n} und erscheint sofort bei allen.",
    "tasting.flow.grow.hintSolo": "Der neue Wein wird Wein {n}.",
    "tasting.flow.grow.scan": "Flasche scannen",
    "tasting.flow.grow.search": "Wein suchen",
    "tasting.flow.grow.blind": "Blinden Wein hinzufügen",
    "tasting.flow.grow.invite": "Personen einladen",
    "tasting.flow.grow.share": "Link oder QR teilen",
    "tasting.flow.grow.hostOnly": "Nur der Gastgeber fügt Weine hinzu.",
    "tasting.flow.grow.searchTitle": "Wein suchen",
    "tasting.flow.grow.addAs": "Als Wein {n} hinzufügen",
    "tasting.flow.invite.title": "Personen einladen",
    "tasting.flow.invite.friends": "Freunde",
    "tasting.flow.invite.group": "Gruppe",
    "tasting.flow.invite.link": "Link / QR",
    "tasting.flow.invite.send": "Einladung senden ({n})",
    "tasting.flow.invite.sent": "Eingeladen.",
    "tasting.flow.invite.signIn": "Melde dich an, um Freunde und Gruppen einzuladen.",
    "tasting.flow.invite.qr": "QR-Code der Verkostung",
    "tasting.flow.invite.pending": "Eingeladen",
    "tasting.flow.people.host": "Gastgeber",
    "tasting.flow.people.you": "Du",
    "tasting.flow.switch.title": "Übersicht",
    "tasting.flow.switch.switch": "Wein wechseln",
    "tasting.flow.switch.done": "Verkostet",
    "tasting.flow.switch.now": "Jetzt",
    "tasting.flow.switch.todo": "Noch nicht",
    "tasting.flow.switch.matrix": "Fortschritt pro Person",
    "tasting.flow.switch.counts": "{done} von {total} fertig",
    "tasting.flow.switch.results": "Zur gemeinsamen Verkostung",
    "tasting.flow.quick.title": "Schnelle Probe",
    "tasting.flow.quick.score": "Bewertung",
    "tasting.flow.quick.scoreHint": "Ein Tipp genügt",
    "tasting.flow.quick.comments": "Anmerkungen",
    "tasting.flow.quick.done": "Fertig",
    "tasting.flow.quick.families": "{n} Familien",
    "tasting.flow.finish": "Verkostung abschließen",
    "tasting.flow.flight.mine": "Meine Verkostung",
    "journal.tasting.label": "Neue Verkostung",
    "aroma.family.floral": "Blumig",
    "aroma.family.green-fruit": "Grüne Frucht",
    "aroma.family.citrus": "Zitrus",
    "aroma.family.stone-fruit": "Steinobst",
    "aroma.family.tropical-fruit": "Tropische Frucht",
    "aroma.family.red-fruit": "Rote Frucht",
    "aroma.family.black-fruit": "Schwarze Frucht",
    "aroma.family.herbaceous": "Grün-vegetabil",
    "aroma.family.herbal": "Kräuter",
    "aroma.family.spice-fresh": "Scharfe Gewürze",
    "aroma.family.mineral": "Mineralisch",
    "aroma.family.yeast": "Hefe & Schale",
    "aroma.family.malolactic": "Cremig",
    "aroma.family.oak": "Eiche",
    "aroma.family.oxidative": "Bewusste Oxidation",
    "aroma.family.fruit-development": "Fruchtentwicklung",
    "aroma.family.bottle-age": "Flaschenreife",
  },
  fr: {
    "tasting.flow.start.title": "Nouvelle dégustation",
    "tasting.flow.start.heading": "Dégustation",
    "tasting.flow.start.paths":
      "Les trois mènent à la même dégustation. Vous pouvez toujours ajouter des personnes et des vins plus tard.",
    "tasting.flow.depth.label": "Profondeur",
    "tasting.flow.depth.full": "Complète",
    "tasting.flow.depth.quick": "Rapide",
    "tasting.flow.start.fullHint": "Complète : aspect, nez, bouche et structure, étape par étape.",
    "tasting.flow.start.quickHint":
      "Rapide : seulement des familles d'arômes, une note et vos remarques — environ 90 secondes par vin.",
    "tasting.flow.start.scan": "Scanner une bouteille",
    "tasting.flow.start.invite": "Inviter des personnes",
    "tasting.flow.start.share": "Partager un lien ou un QR",
    "tasting.flow.start.blind": "Déguster à l'aveugle",
    "tasting.flow.start.blindHint": "Les étiquettes restent cachées jusqu'à la révélation",
    "tasting.flow.start.later": "Vous pouvez aussi ajouter des personnes pendant la dégustation.",
    "tasting.flow.start.resumeTitle": "Une dégustation est encore ouverte",
    "tasting.flow.start.resumeBody": "{title} : {done} vins sur {total} terminés.",
    "tasting.flow.start.resume": "Reprendre",
    "tasting.flow.start.discard": "Recommencer",
    "tasting.flow.lobby.ready": "{done} sur {total} terminés",
    "tasting.flow.lobby.empty": "Pas encore de vin. Ajoutez-en un pour commencer.",
    "tasting.flow.lobby.wines": "Vins",
    "tasting.flow.lobby.people": "Personnes ({n})",
    "tasting.flow.lobby.joined": "{names} participent",
    "tasting.flow.lobby.invited": "{names} invité(s)",
    "tasting.flow.lobby.alone": "Vous seul, pour l'instant.",
    "tasting.flow.lobby.code": "Code",
    "tasting.flow.lobby.copyLink": "Copier le lien",
    "tasting.flow.lobby.copied": "Lien copié",
    "tasting.flow.lobby.linkHint":
      "Quiconque ouvre le lien ou scanne le code rejoint cette dégustation.",
    "tasting.flow.lobby.makeLink": "Créer un lien ou un QR",
    "tasting.flow.lobby.begin": "Commencer par le vin {n}",
    "tasting.flow.lobby.needWine": "Ajoutez d'abord un vin pour commencer.",
    "tasting.flow.lobby.waiting": "En attente des autres",
    "tasting.flow.lobby.waitingHost": "En attente du début par l'hôte",
    "tasting.flow.lobby.blindWine": "Vin {n} (à l'aveugle)",
    "tasting.flow.lobby.refresh": "Actualiser",
    "tasting.flow.wineOf": "{n} / {total}",
    "tasting.flow.step": "Étape {n} sur {total} : {name}",
    "tasting.flow.steps": "Étapes",
    "tasting.flow.invite": "Inviter",
    "tasting.flow.addWine": "Ajouter un vin",
    "tasting.flow.next": "Continuer · {name}",
    "tasting.flow.structure": "Structure & verdict",
    "tasting.flow.summary": "Résumé",
    "tasting.flow.blindCard": "À l'aveugle : l'étiquette reste cachée",
    "tasting.flow.blindCardHint": "La couleur, vous la jugez quand même.",
    "tasting.flow.mystery": "Bouteille mystère",
    "tasting.flow.progress": "Progression",
    "tasting.flow.wines": "Vins",
    "tasting.flow.aroma.selected": "Choisis",
    "tasting.flow.aroma.count": "{n} choisi(s)",
    "tasting.flow.aroma.primary": "Du raisin",
    "tasting.flow.aroma.secondary": "De la cave",
    "tasting.flow.aroma.tertiary": "Du temps",
    "tasting.flow.aroma.sameAsNose": "Comme le nez",
    "tasting.flow.aroma.remove": "Retirer {name}",
    "tasting.flow.aroma.cap": "Choisissez jusqu'à {n} familles.",
    "tasting.flow.aroma.swatch": "Couleur de la famille {name}",
    "tasting.flow.more": "Plus (sucrosité, corps, finale, mousse)",
    "tasting.flow.summary.hint": "Touchez une ligne pour modifier cette étape",
    "tasting.flow.summary.nothing": "Rien de choisi",
    "tasting.flow.summary.offline":
      "Pas de connexion — votre note est gardée et envoyée plus tard.",
    "tasting.flow.summary.queued":
      "Gardée sur cet appareil ; elle sera envoyée dès que la connexion revient.",
    "tasting.flow.summary.needsVerdict": "Choisissez d'abord un verdict sous Structure & verdict.",
    "tasting.flow.summary.saveNext": "Enregistrer et passer au vin {n}",
    "tasting.flow.summary.overview": "Vers l'aperçu",
    "tasting.flow.grow.title": "Agrandir la dégustation",
    "tasting.flow.grow.hint":
      "Le nouveau vin devient le vin {n} et apparaît tout de suite chez tout le monde.",
    "tasting.flow.grow.hintSolo": "Le nouveau vin devient le vin {n}.",
    "tasting.flow.grow.scan": "Scanner une bouteille",
    "tasting.flow.grow.search": "Chercher un vin",
    "tasting.flow.grow.blind": "Ajouter un vin à l'aveugle",
    "tasting.flow.grow.invite": "Inviter des personnes",
    "tasting.flow.grow.share": "Partager un lien ou un QR",
    "tasting.flow.grow.hostOnly": "Seul l'hôte ajoute des vins.",
    "tasting.flow.grow.searchTitle": "Chercher un vin",
    "tasting.flow.grow.addAs": "Ajouter comme vin {n}",
    "tasting.flow.invite.title": "Inviter des personnes",
    "tasting.flow.invite.friends": "Amis",
    "tasting.flow.invite.group": "Groupe",
    "tasting.flow.invite.link": "Lien / QR",
    "tasting.flow.invite.send": "Envoyer l'invitation ({n})",
    "tasting.flow.invite.sent": "Invités.",
    "tasting.flow.invite.signIn": "Connectez-vous pour inviter des amis et des groupes.",
    "tasting.flow.invite.qr": "QR code de la dégustation",
    "tasting.flow.invite.pending": "Invité",
    "tasting.flow.people.host": "Hôte",
    "tasting.flow.people.you": "Vous",
    "tasting.flow.switch.title": "Aperçu",
    "tasting.flow.switch.switch": "Changer de vin",
    "tasting.flow.switch.done": "Dégusté",
    "tasting.flow.switch.now": "En cours",
    "tasting.flow.switch.todo": "Pas encore",
    "tasting.flow.switch.matrix": "Progression par personne",
    "tasting.flow.switch.counts": "{done} sur {total} terminés",
    "tasting.flow.switch.results": "Vers la dégustation commune",
    "tasting.flow.quick.title": "Dégustation rapide",
    "tasting.flow.quick.score": "Note",
    "tasting.flow.quick.scoreHint": "Un seul geste suffit",
    "tasting.flow.quick.comments": "Remarques",
    "tasting.flow.quick.done": "Terminé",
    "tasting.flow.quick.families": "{n} familles",
    "tasting.flow.finish": "Terminer la dégustation",
    "tasting.flow.flight.mine": "Ma dégustation",
    "journal.tasting.label": "Nouvelle dégustation",
    "aroma.family.floral": "Floral",
    "aroma.family.green-fruit": "Fruits verts",
    "aroma.family.citrus": "Agrumes",
    "aroma.family.stone-fruit": "Fruits à noyau",
    "aroma.family.tropical-fruit": "Fruits tropicaux",
    "aroma.family.red-fruit": "Fruits rouges",
    "aroma.family.black-fruit": "Fruits noirs",
    "aroma.family.herbaceous": "Végétal",
    "aroma.family.herbal": "Herbes",
    "aroma.family.spice-fresh": "Épices vives",
    "aroma.family.mineral": "Minéral",
    "aroma.family.yeast": "Levure & lies",
    "aroma.family.malolactic": "Crémeux",
    "aroma.family.oak": "Chêne",
    "aroma.family.oxidative": "Oxydation voulue",
    "aroma.family.fruit-development": "Évolution du fruit",
    "aroma.family.bottle-age": "Vieillissement en bouteille",
  },
  es: {
    "tasting.flow.start.title": "Nueva cata",
    "tasting.flow.start.heading": "Cata",
    "tasting.flow.start.paths":
      "Las tres llevan a la misma cata. Siempre puedes añadir personas y vinos más tarde.",
    "tasting.flow.depth.label": "Profundidad",
    "tasting.flow.depth.full": "Completa",
    "tasting.flow.depth.quick": "Rápida",
    "tasting.flow.start.fullHint": "Completa: vista, nariz, boca y estructura, paso a paso.",
    "tasting.flow.start.quickHint":
      "Rápida: solo familias de aromas, una puntuación y tus comentarios — unos 90 segundos por vino.",
    "tasting.flow.start.scan": "Escanear una botella",
    "tasting.flow.start.invite": "Invitar a personas",
    "tasting.flow.start.share": "Compartir enlace o QR",
    "tasting.flow.start.blind": "Catar a ciegas",
    "tasting.flow.start.blindHint": "Las etiquetas siguen ocultas hasta la revelación",
    "tasting.flow.start.later": "También puedes añadir personas durante la cata.",
    "tasting.flow.start.resumeTitle": "Todavía tienes una cata abierta",
    "tasting.flow.start.resumeBody": "{title}: {done} de {total} vinos terminados.",
    "tasting.flow.start.resume": "Continuar",
    "tasting.flow.start.discard": "Empezar de nuevo",
    "tasting.flow.lobby.ready": "{done} de {total} terminados",
    "tasting.flow.lobby.empty": "Aún no hay vinos. Añade uno para empezar.",
    "tasting.flow.lobby.wines": "Vinos",
    "tasting.flow.lobby.people": "Personas ({n})",
    "tasting.flow.lobby.joined": "{names} participan",
    "tasting.flow.lobby.invited": "{names} invitados",
    "tasting.flow.lobby.alone": "Solo tú, por ahora.",
    "tasting.flow.lobby.code": "Código",
    "tasting.flow.lobby.copyLink": "Copiar enlace",
    "tasting.flow.lobby.copied": "Enlace copiado",
    "tasting.flow.lobby.linkHint": "Quien abra el enlace o escanee el código se une a esta cata.",
    "tasting.flow.lobby.makeLink": "Crear enlace o QR",
    "tasting.flow.lobby.begin": "Empezar con el vino {n}",
    "tasting.flow.lobby.needWine": "Añade primero un vino para empezar.",
    "tasting.flow.lobby.waiting": "Esperando a los demás",
    "tasting.flow.lobby.waitingHost": "Esperando a que el anfitrión empiece",
    "tasting.flow.lobby.blindWine": "Vino {n} (a ciegas)",
    "tasting.flow.lobby.refresh": "Actualizar",
    "tasting.flow.wineOf": "{n} / {total}",
    "tasting.flow.step": "Paso {n} de {total}: {name}",
    "tasting.flow.steps": "Pasos",
    "tasting.flow.invite": "Invitar",
    "tasting.flow.addWine": "Añadir vino",
    "tasting.flow.next": "Seguir · {name}",
    "tasting.flow.structure": "Estructura y veredicto",
    "tasting.flow.summary": "Resumen",
    "tasting.flow.blindCard": "A ciegas: la etiqueta sigue oculta",
    "tasting.flow.blindCardHint": "El color sí lo juzgas.",
    "tasting.flow.mystery": "Botella misteriosa",
    "tasting.flow.progress": "Progreso",
    "tasting.flow.wines": "Vinos",
    "tasting.flow.aroma.selected": "Elegidos",
    "tasting.flow.aroma.count": "{n} elegidos",
    "tasting.flow.aroma.primary": "De la uva",
    "tasting.flow.aroma.secondary": "De la bodega",
    "tasting.flow.aroma.tertiary": "Del tiempo",
    "tasting.flow.aroma.sameAsNose": "Igual que la nariz",
    "tasting.flow.aroma.remove": "Quitar {name}",
    "tasting.flow.aroma.cap": "Elige hasta {n} familias.",
    "tasting.flow.aroma.swatch": "Color de la familia {name}",
    "tasting.flow.more": "Más (dulzor, cuerpo, final, espuma)",
    "tasting.flow.summary.hint": "Toca una línea para cambiar ese paso",
    "tasting.flow.summary.nothing": "Nada elegido",
    "tasting.flow.summary.offline": "Sin conexión — tu nota se guarda y se envía más tarde.",
    "tasting.flow.summary.queued":
      "Guardada en este dispositivo; se enviará en cuanto haya conexión.",
    "tasting.flow.summary.needsVerdict": "Elige primero un veredicto en Estructura y veredicto.",
    "tasting.flow.summary.saveNext": "Guardar e ir al vino {n}",
    "tasting.flow.summary.overview": "Ir al resumen general",
    "tasting.flow.grow.title": "Ampliar la cata",
    "tasting.flow.grow.hint":
      "El vino nuevo pasa a ser el vino {n} y aparece al instante para todos.",
    "tasting.flow.grow.hintSolo": "El vino nuevo pasa a ser el vino {n}.",
    "tasting.flow.grow.scan": "Escanear una botella",
    "tasting.flow.grow.search": "Buscar un vino",
    "tasting.flow.grow.blind": "Añadir un vino a ciegas",
    "tasting.flow.grow.invite": "Invitar a personas",
    "tasting.flow.grow.share": "Compartir enlace o QR",
    "tasting.flow.grow.hostOnly": "Solo el anfitrión añade vinos.",
    "tasting.flow.grow.searchTitle": "Buscar un vino",
    "tasting.flow.grow.addAs": "Añadir como vino {n}",
    "tasting.flow.invite.title": "Invitar a personas",
    "tasting.flow.invite.friends": "Amigos",
    "tasting.flow.invite.group": "Grupo",
    "tasting.flow.invite.link": "Enlace / QR",
    "tasting.flow.invite.send": "Enviar invitación ({n})",
    "tasting.flow.invite.sent": "Invitados.",
    "tasting.flow.invite.signIn": "Inicia sesión para invitar a amigos y grupos.",
    "tasting.flow.invite.qr": "Código QR de la cata",
    "tasting.flow.invite.pending": "Invitado",
    "tasting.flow.people.host": "Anfitrión",
    "tasting.flow.people.you": "Tú",
    "tasting.flow.switch.title": "Resumen general",
    "tasting.flow.switch.switch": "Cambiar de vino",
    "tasting.flow.switch.done": "Catado",
    "tasting.flow.switch.now": "Ahora",
    "tasting.flow.switch.todo": "Aún no",
    "tasting.flow.switch.matrix": "Progreso por persona",
    "tasting.flow.switch.counts": "{done} de {total} terminados",
    "tasting.flow.switch.results": "Ir a la cata compartida",
    "tasting.flow.quick.title": "Cata rápida",
    "tasting.flow.quick.score": "Puntuación",
    "tasting.flow.quick.scoreHint": "Un toque basta",
    "tasting.flow.quick.comments": "Comentarios",
    "tasting.flow.quick.done": "Hecho",
    "tasting.flow.quick.families": "{n} familias",
    "tasting.flow.finish": "Terminar la cata",
    "tasting.flow.flight.mine": "Mi cata",
    "journal.tasting.label": "Nueva cata",
    "aroma.family.floral": "Floral",
    "aroma.family.green-fruit": "Fruta verde",
    "aroma.family.citrus": "Cítricos",
    "aroma.family.stone-fruit": "Fruta de hueso",
    "aroma.family.tropical-fruit": "Fruta tropical",
    "aroma.family.red-fruit": "Fruta roja",
    "aroma.family.black-fruit": "Fruta negra",
    "aroma.family.herbaceous": "Vegetal",
    "aroma.family.herbal": "Hierbas",
    "aroma.family.spice-fresh": "Especias vivas",
    "aroma.family.mineral": "Mineral",
    "aroma.family.yeast": "Levadura y lías",
    "aroma.family.malolactic": "Cremoso",
    "aroma.family.oak": "Roble",
    "aroma.family.oxidative": "Oxidación buscada",
    "aroma.family.fruit-development": "Evolución de la fruta",
    "aroma.family.bottle-age": "Crianza en botella",
  },
  it: {
    "tasting.flow.start.title": "Nuova degustazione",
    "tasting.flow.start.heading": "Degustazione",
    "tasting.flow.start.paths":
      "Tutte e tre portano alla stessa degustazione. Puoi sempre aggiungere persone e vini più tardi.",
    "tasting.flow.depth.label": "Profondità",
    "tasting.flow.depth.full": "Completa",
    "tasting.flow.depth.quick": "Rapida",
    "tasting.flow.start.fullHint": "Completa: aspetto, naso, bocca e struttura, passo dopo passo.",
    "tasting.flow.start.quickHint":
      "Rapida: solo famiglie di aromi, un punteggio e le tue note — circa 90 secondi per vino.",
    "tasting.flow.start.scan": "Scansiona una bottiglia",
    "tasting.flow.start.invite": "Invita persone",
    "tasting.flow.start.share": "Condividi link o QR",
    "tasting.flow.start.blind": "Degusta alla cieca",
    "tasting.flow.start.blindHint": "Le etichette restano nascoste fino alla rivelazione",
    "tasting.flow.start.later": "Puoi aggiungere persone anche durante la degustazione.",
    "tasting.flow.start.resumeTitle": "Hai ancora una degustazione aperta",
    "tasting.flow.start.resumeBody": "{title}: {done} vini su {total} completati.",
    "tasting.flow.start.resume": "Riprendi",
    "tasting.flow.start.discard": "Ricomincia",
    "tasting.flow.lobby.ready": "{done} su {total} completati",
    "tasting.flow.lobby.empty": "Ancora nessun vino. Aggiungine uno per iniziare.",
    "tasting.flow.lobby.wines": "Vini",
    "tasting.flow.lobby.people": "Persone ({n})",
    "tasting.flow.lobby.joined": "{names} partecipano",
    "tasting.flow.lobby.invited": "{names} invitati",
    "tasting.flow.lobby.alone": "Solo tu, per ora.",
    "tasting.flow.lobby.code": "Codice",
    "tasting.flow.lobby.copyLink": "Copia link",
    "tasting.flow.lobby.copied": "Link copiato",
    "tasting.flow.lobby.linkHint":
      "Chi apre il link o scansiona il codice partecipa a questa degustazione.",
    "tasting.flow.lobby.makeLink": "Crea link o QR",
    "tasting.flow.lobby.begin": "Inizia con il vino {n}",
    "tasting.flow.lobby.needWine": "Aggiungi prima un vino per iniziare.",
    "tasting.flow.lobby.waiting": "In attesa degli altri",
    "tasting.flow.lobby.waitingHost": "In attesa che l'ospitante inizi",
    "tasting.flow.lobby.blindWine": "Vino {n} (alla cieca)",
    "tasting.flow.lobby.refresh": "Aggiorna",
    "tasting.flow.wineOf": "{n} / {total}",
    "tasting.flow.step": "Passo {n} di {total}: {name}",
    "tasting.flow.steps": "Passi",
    "tasting.flow.invite": "Invita",
    "tasting.flow.addWine": "Aggiungi vino",
    "tasting.flow.next": "Avanti · {name}",
    "tasting.flow.structure": "Struttura e giudizio",
    "tasting.flow.summary": "Riepilogo",
    "tasting.flow.blindCard": "Alla cieca: l'etichetta resta nascosta",
    "tasting.flow.blindCardHint": "Il colore lo giudichi comunque.",
    "tasting.flow.mystery": "Bottiglia misteriosa",
    "tasting.flow.progress": "Avanzamento",
    "tasting.flow.wines": "Vini",
    "tasting.flow.aroma.selected": "Scelti",
    "tasting.flow.aroma.count": "{n} scelti",
    "tasting.flow.aroma.primary": "Dall'uva",
    "tasting.flow.aroma.secondary": "Dalla cantina",
    "tasting.flow.aroma.tertiary": "Dal tempo",
    "tasting.flow.aroma.sameAsNose": "Come il naso",
    "tasting.flow.aroma.remove": "Rimuovi {name}",
    "tasting.flow.aroma.cap": "Scegli fino a {n} famiglie.",
    "tasting.flow.aroma.swatch": "Colore della famiglia {name}",
    "tasting.flow.more": "Altro (dolcezza, corpo, finale, perlage)",
    "tasting.flow.summary.hint": "Tocca una riga per cambiare quel passo",
    "tasting.flow.summary.nothing": "Niente di scelto",
    "tasting.flow.summary.offline":
      "Nessuna connessione — la tua nota viene conservata e inviata più tardi.",
    "tasting.flow.summary.queued":
      "Conservata su questo dispositivo; viene inviata appena torna la connessione.",
    "tasting.flow.summary.needsVerdict": "Scegli prima un giudizio in Struttura e giudizio.",
    "tasting.flow.summary.saveNext": "Salva e vai al vino {n}",
    "tasting.flow.summary.overview": "Vai al riepilogo generale",
    "tasting.flow.grow.title": "Amplia la degustazione",
    "tasting.flow.grow.hint": "Il nuovo vino diventa il vino {n} e compare subito per tutti.",
    "tasting.flow.grow.hintSolo": "Il nuovo vino diventa il vino {n}.",
    "tasting.flow.grow.scan": "Scansiona una bottiglia",
    "tasting.flow.grow.search": "Cerca un vino",
    "tasting.flow.grow.blind": "Aggiungi un vino alla cieca",
    "tasting.flow.grow.invite": "Invita persone",
    "tasting.flow.grow.share": "Condividi link o QR",
    "tasting.flow.grow.hostOnly": "Solo l'ospitante aggiunge vini.",
    "tasting.flow.grow.searchTitle": "Cerca un vino",
    "tasting.flow.grow.addAs": "Aggiungi come vino {n}",
    "tasting.flow.invite.title": "Invita persone",
    "tasting.flow.invite.friends": "Amici",
    "tasting.flow.invite.group": "Gruppo",
    "tasting.flow.invite.link": "Link / QR",
    "tasting.flow.invite.send": "Invia invito ({n})",
    "tasting.flow.invite.sent": "Invitati.",
    "tasting.flow.invite.signIn": "Accedi per invitare amici e gruppi.",
    "tasting.flow.invite.qr": "Codice QR della degustazione",
    "tasting.flow.invite.pending": "Invitato",
    "tasting.flow.people.host": "Ospitante",
    "tasting.flow.people.you": "Tu",
    "tasting.flow.switch.title": "Riepilogo generale",
    "tasting.flow.switch.switch": "Cambia vino",
    "tasting.flow.switch.done": "Degustato",
    "tasting.flow.switch.now": "Ora",
    "tasting.flow.switch.todo": "Non ancora",
    "tasting.flow.switch.matrix": "Avanzamento per persona",
    "tasting.flow.switch.counts": "{done} su {total} completati",
    "tasting.flow.switch.results": "Vai alla degustazione di gruppo",
    "tasting.flow.quick.title": "Assaggio rapido",
    "tasting.flow.quick.score": "Punteggio",
    "tasting.flow.quick.scoreHint": "Un tocco basta",
    "tasting.flow.quick.comments": "Note",
    "tasting.flow.quick.done": "Fatto",
    "tasting.flow.quick.families": "{n} famiglie",
    "tasting.flow.finish": "Concludi la degustazione",
    "tasting.flow.flight.mine": "La mia degustazione",
    "journal.tasting.label": "Nuova degustazione",
    "aroma.family.floral": "Floreale",
    "aroma.family.green-fruit": "Frutta verde",
    "aroma.family.citrus": "Agrumi",
    "aroma.family.stone-fruit": "Frutta a nocciolo",
    "aroma.family.tropical-fruit": "Frutta tropicale",
    "aroma.family.red-fruit": "Frutta rossa",
    "aroma.family.black-fruit": "Frutta nera",
    "aroma.family.herbaceous": "Vegetale",
    "aroma.family.herbal": "Erbe",
    "aroma.family.spice-fresh": "Spezie vivaci",
    "aroma.family.mineral": "Minerale",
    "aroma.family.yeast": "Lieviti e fecce",
    "aroma.family.malolactic": "Cremoso",
    "aroma.family.oak": "Rovere",
    "aroma.family.oxidative": "Ossidazione voluta",
    "aroma.family.fruit-development": "Evoluzione del frutto",
    "aroma.family.bottle-age": "Affinamento in bottiglia",
  },
  pt: {
    "tasting.flow.start.title": "Nova prova",
    "tasting.flow.start.heading": "Prova",
    "tasting.flow.start.paths":
      "As três levam à mesma prova. Podes sempre acrescentar pessoas e vinhos mais tarde.",
    "tasting.flow.depth.label": "Profundidade",
    "tasting.flow.depth.full": "Completa",
    "tasting.flow.depth.quick": "Rápida",
    "tasting.flow.start.fullHint": "Completa: aspeto, nariz, boca e estrutura, passo a passo.",
    "tasting.flow.start.quickHint":
      "Rápida: só famílias de aromas, uma pontuação e os teus comentários — cerca de 90 segundos por vinho.",
    "tasting.flow.start.scan": "Ler uma garrafa",
    "tasting.flow.start.invite": "Convidar pessoas",
    "tasting.flow.start.share": "Partilhar link ou QR",
    "tasting.flow.start.blind": "Provar às cegas",
    "tasting.flow.start.blindHint": "Os rótulos ficam escondidos até à revelação",
    "tasting.flow.start.later": "Também podes acrescentar pessoas durante a prova.",
    "tasting.flow.start.resumeTitle": "Ainda tens uma prova aberta",
    "tasting.flow.start.resumeBody": "{title}: {done} de {total} vinhos concluídos.",
    "tasting.flow.start.resume": "Retomar",
    "tasting.flow.start.discard": "Recomeçar",
    "tasting.flow.lobby.ready": "{done} de {total} concluídos",
    "tasting.flow.lobby.empty": "Ainda sem vinhos. Acrescenta um para começar.",
    "tasting.flow.lobby.wines": "Vinhos",
    "tasting.flow.lobby.people": "Pessoas ({n})",
    "tasting.flow.lobby.joined": "{names} participam",
    "tasting.flow.lobby.invited": "{names} convidados",
    "tasting.flow.lobby.alone": "Só tu, por agora.",
    "tasting.flow.lobby.code": "Código",
    "tasting.flow.lobby.copyLink": "Copiar link",
    "tasting.flow.lobby.copied": "Link copiado",
    "tasting.flow.lobby.linkHint": "Quem abrir o link ou ler o código participa nesta prova.",
    "tasting.flow.lobby.makeLink": "Criar link ou QR",
    "tasting.flow.lobby.begin": "Começar pelo vinho {n}",
    "tasting.flow.lobby.needWine": "Acrescenta primeiro um vinho para começar.",
    "tasting.flow.lobby.waiting": "À espera dos outros",
    "tasting.flow.lobby.waitingHost": "À espera de que o anfitrião comece",
    "tasting.flow.lobby.blindWine": "Vinho {n} (às cegas)",
    "tasting.flow.lobby.refresh": "Atualizar",
    "tasting.flow.wineOf": "{n} / {total}",
    "tasting.flow.step": "Passo {n} de {total}: {name}",
    "tasting.flow.steps": "Passos",
    "tasting.flow.invite": "Convidar",
    "tasting.flow.addWine": "Acrescentar vinho",
    "tasting.flow.next": "Continuar · {name}",
    "tasting.flow.structure": "Estrutura e veredito",
    "tasting.flow.summary": "Resumo",
    "tasting.flow.blindCard": "Às cegas: o rótulo fica escondido",
    "tasting.flow.blindCardHint": "A cor continuas a avaliar.",
    "tasting.flow.mystery": "Garrafa misteriosa",
    "tasting.flow.progress": "Progresso",
    "tasting.flow.wines": "Vinhos",
    "tasting.flow.aroma.selected": "Escolhidos",
    "tasting.flow.aroma.count": "{n} escolhidos",
    "tasting.flow.aroma.primary": "Da uva",
    "tasting.flow.aroma.secondary": "Da cave",
    "tasting.flow.aroma.tertiary": "Do tempo",
    "tasting.flow.aroma.sameAsNose": "Igual ao nariz",
    "tasting.flow.aroma.remove": "Remover {name}",
    "tasting.flow.aroma.cap": "Escolhe até {n} famílias.",
    "tasting.flow.aroma.swatch": "Cor da família {name}",
    "tasting.flow.more": "Mais (doçura, corpo, final, espuma)",
    "tasting.flow.summary.hint": "Toca numa linha para alterar esse passo",
    "tasting.flow.summary.nothing": "Nada escolhido",
    "tasting.flow.summary.offline":
      "Sem ligação — a tua nota fica guardada e é enviada mais tarde.",
    "tasting.flow.summary.queued":
      "Guardada neste dispositivo; é enviada assim que houver ligação.",
    "tasting.flow.summary.needsVerdict": "Escolhe primeiro um veredito em Estrutura e veredito.",
    "tasting.flow.summary.saveNext": "Guardar e ir para o vinho {n}",
    "tasting.flow.summary.overview": "Ir para o resumo geral",
    "tasting.flow.grow.title": "Alargar a prova",
    "tasting.flow.grow.hint": "O vinho novo passa a ser o vinho {n} e aparece logo para todos.",
    "tasting.flow.grow.hintSolo": "O vinho novo passa a ser o vinho {n}.",
    "tasting.flow.grow.scan": "Ler uma garrafa",
    "tasting.flow.grow.search": "Procurar um vinho",
    "tasting.flow.grow.blind": "Acrescentar um vinho às cegas",
    "tasting.flow.grow.invite": "Convidar pessoas",
    "tasting.flow.grow.share": "Partilhar link ou QR",
    "tasting.flow.grow.hostOnly": "Só o anfitrião acrescenta vinhos.",
    "tasting.flow.grow.searchTitle": "Procurar um vinho",
    "tasting.flow.grow.addAs": "Acrescentar como vinho {n}",
    "tasting.flow.invite.title": "Convidar pessoas",
    "tasting.flow.invite.friends": "Amigos",
    "tasting.flow.invite.group": "Grupo",
    "tasting.flow.invite.link": "Link / QR",
    "tasting.flow.invite.send": "Enviar convite ({n})",
    "tasting.flow.invite.sent": "Convidados.",
    "tasting.flow.invite.signIn": "Inicia sessão para convidar amigos e grupos.",
    "tasting.flow.invite.qr": "Código QR da prova",
    "tasting.flow.invite.pending": "Convidado",
    "tasting.flow.people.host": "Anfitrião",
    "tasting.flow.people.you": "Você",
    "tasting.flow.switch.title": "Resumo geral",
    "tasting.flow.switch.switch": "Mudar de vinho",
    "tasting.flow.switch.done": "Provado",
    "tasting.flow.switch.now": "Agora",
    "tasting.flow.switch.todo": "Ainda não",
    "tasting.flow.switch.matrix": "Progresso por pessoa",
    "tasting.flow.switch.counts": "{done} de {total} concluídos",
    "tasting.flow.switch.results": "Ir para a prova de grupo",
    "tasting.flow.quick.title": "Prova rápida",
    "tasting.flow.quick.score": "Pontuação",
    "tasting.flow.quick.scoreHint": "Um toque basta",
    "tasting.flow.quick.comments": "Comentários",
    "tasting.flow.quick.done": "Feito",
    "tasting.flow.quick.families": "{n} famílias",
    "tasting.flow.finish": "Terminar a prova",
    "tasting.flow.flight.mine": "A minha prova",
    "journal.tasting.label": "Nova prova",
    "aroma.family.floral": "Floral",
    "aroma.family.green-fruit": "Fruta verde",
    "aroma.family.citrus": "Cítricos",
    "aroma.family.stone-fruit": "Fruta de caroço",
    "aroma.family.tropical-fruit": "Fruta tropical",
    "aroma.family.red-fruit": "Fruta vermelha",
    "aroma.family.black-fruit": "Fruta preta",
    "aroma.family.herbaceous": "Vegetal",
    "aroma.family.herbal": "Ervas",
    "aroma.family.spice-fresh": "Especiarias vivas",
    "aroma.family.mineral": "Mineral",
    "aroma.family.yeast": "Leveduras e borras",
    "aroma.family.malolactic": "Cremoso",
    "aroma.family.oak": "Carvalho",
    "aroma.family.oxidative": "Oxidação desejada",
    "aroma.family.fruit-development": "Evolução da fruta",
    "aroma.family.bottle-age": "Estágio em garrafa",
  },
} as const;
